<template>
    <router-view />
</template>

<style lang="scss">
@import 'colorui/animation.css';
@import 'colorui/main.scss';
@import 'colorui/element.scss';
@import 'colorui/project.css';
@import 'colorui/common.scss';
</style>
